const getInitialLastActiveStep = ({
  isShow,
  isEdit,
  isPreAvaliation,
  fromCreate,
}) => {
  if (fromCreate) return 1
  if (isShow) return isPreAvaliation ? 4 : 5
  if (isEdit) return isPreAvaliation ? 3 : 4
  return 0
}

export default getInitialLastActiveStep
